<template>
	<div id="level_box">
		<el-row>
			<el-col :span="18">
				<el-table :data="levelList" stripe highlight-current-row @current-change="levelListChange"
					style="width: 100%" height="700">
					<el-table-column prop="id" label="ID" width="55"></el-table-column>
					<el-table-column prop="name" label="等级名称"></el-table-column>
					<!--el-table-column label="护士站滞留时间">
            <template slot-scope="scope">
              {{scope.row.nurseStationTimeLong|ToStr}}
            </template>
          </el-table-column>
          <el-table-column label="卫生间滞留时间">
            <template slot-scope="scope">
              {{scope.row.toiletTimeLong|ToStr}}
            </template>
          </el-table-column>
          <el-table-column label="其他滞留时间">
            <template slot-scope="scope">
              {{scope.row.otherTimeLong|ToStr}}
            </template>
          </el-table-column-->
					<el-table-column prop="description" label="备注"></el-table-column>
				</el-table>
			</el-col>
			<el-col :span="6">
				<el-form label-width="120px">
					<el-form-item label="等级名称">
						<el-input v-model="depForm.name"></el-input>
					</el-form-item>
					<el-form-item label="颜色">
						<el-input v-model="inputColor"></el-input>
					</el-form-item>
					<el-form-item label="描述">
						<el-input type="textarea" v-model="depForm.description" style="width: 200px;"
							:autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-button type="success" @click="goSave">{{saveTxt}}</el-button>
						<el-button type="danger" @click="goDel">{{delTxt}}</el-button>
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>

	</div>
</template>
<script>
	export default {
		mixins: [require("@/mymixins").default],
		data() {
			return {
				levelList: [],
				inputColor: "",
				depForm: {
					buildingNo: "",
					deptNo: "",
					deptName: "",
					superviseFlag: 0,
					style: {
						color: ''
					}
				},
				nowId: 0,
				saveTxt: "新增",
				delTxt: "清空"
			}
		},
		filters: {
			ToStr: function(value) {
				return value + "分钟";
			}
		},
		mounted() {
			this.getLevelList();
		},
		methods: {
			initForm() {
				this.nowId = 0;
				this.saveTxt = "新增";
				this.delTxt = "清空";
				this.inputColor = "";
				this.depForm = {
					buildingNo: "",
					deptNo: "",
					deptName: "",
					superviseFlag: 0,
					style: {
						color: ''
					}
				};
				this.getLevelList();
			},
			goSave() {
				let url = "";
				let tempData = this.depForm;
				if (!this.inputColor) {
					this.$message.error("请输入颜色");
					return false;
				} else {
					this.depForm.style.color = this.inputColor;
				}
				if (this.nowId) {
					//修改
					tempData.id = this.nowId;
					url = "api/objectsClass/modify";
				} else {
					//新增
					url = "api/objectsClass/add";
				}
				this.post(url, tempData).then(res => {
					if (res.success == true) {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
					} else {
						this.$message.error(res.detail);
					}
					this.initForm();
				});
			},
			goDelete() {
				if (this.nowId) {
					//删除
					this.post("api/objectsClass/remove", [this.nowId]).then(res => {
						if (res.success == true) {
							this.$message({
								message: '删除成功',
								type: 'success'
							});
						} else {
							this.$message.error(res.detail);
						}
					});
				}
				this.initForm();
			},
			goDel() {
				if (this.delTxt == "清空") {
					this.initForm();
				} else {
					this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.goDelete();
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '取消删除'
						});
						this.initForm();
					});
				}

			},
			levelListChange(val) {
				console.log(val);
				if (val) {
					if (!val.style) {
						val.style = {
							color: ''
						};
					}
					this.inputColor = val.style.color;
					this.depForm = val;
					this.nowId = val.id;
					this.saveTxt = "修改";
					this.delTxt = "删除";
				}

			},
			getLevelList() {
				this.get("api/objectsClass/list", {}).then(res => {
					//console.log(res);
					this.levelList = res.data;
				});
			}
		}
	}
</script>
<style lang="scss">
	#level_box {
		width: 1200px;
	}
</style>
